// extracted by mini-css-extract-plugin
export default {"Tabs":"Tabs_Tabs__XKak3","Tab":"Tabs_Tab__aMe+b","Active":"Tabs_Active__s0saU"};